import React, { useState, useEffect } from "react";
import Confetti from "react-confetti";
import "./ThankYouPage.css";

const ThankYouPage = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [showConfetti, setShowConfetti] = useState(true);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    // Countdown and redirect
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          // window.location.href = "/";
        }
        return prev - 1;
      });
    }, 1000);

    const confettiTimer = setTimeout(() => setShowConfetti(false), 5000);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(interval);
      clearTimeout(confettiTimer);
    };
  }, []);

  return (
    <div className="thankyou-container">
      {showConfetti && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={300}
          colors={["#e63946", "#ffccd5", "#ffffff", "#f87171", "#fca5a5"]}
          gravity={0.15}
          recycle={false}
        />
      )}
      <div className="thankyou-card">
        <h1>🎉 Thank You!</h1>
        <p>Your responses have been submitted successfully.</p>
        <p className="redirect-text">Redirecting to home in {countdown}s...</p>
        <button
          className="thankyou-home-btn"
          onClick={() => (window.location.href = "https://www.acumen.co.in/")}
        >
          Visit Acumen
        </button>
      </div>
    </div>
  );
};

export default ThankYouPage;
